import { render, staticRenderFns } from "./c-card-symbol.vue?vue&type=template&id=59079157&scoped=true"
import script from "./c-card-symbol.vue?vue&type=script&lang=js"
export * from "./c-card-symbol.vue?vue&type=script&lang=js"
import style0 from "./c-card-symbol.vue?vue&type=style&index=0&id=59079157&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59079157",
  null
  
)

export default component.exports